export const site = {
  name: 'Jacob Xiaoyu Wei',
  title: "Jacob Xiaoyu Wei's Website",
  tagline:
    'Engineer with a PhD in math. I make hard software reliable, from fast numerical solvers to production cloud platforms.',
  description:
    'Building software, scientific computing, math, and high performance numerical methods by Jacob Xiaoyu Wei.',
  url: 'https://www.shuhari.me',
  author: 'Jacob Xiaoyu Wei',
  github: 'https://github.com/xywei',
  rss: '/feed.xml',
} as const
